import styles from "../../../styles/components/Modal/Affiliate/AddDeskModal.module.css";
import React, { useEffect, useState, useRef, useContext } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { InputSelector } from "../../UI/InputSelector";
import { createDeskApi } from "../../../utils/api/Admin/desk/createDeskApi";
import { LangContext } from "../../../context/LangContext";
import { ThemeContext } from "../../../context/ThemeContext";

const translations = {
  ru: {
    createDesk: "Создать Деск",
    confirm: "Подтвердить",
    fields: {
      name: "Название",
      description: "Описание",
    },
    generalError: "Произошла ошибка при создании деска.",
    creationError: "Ошибка при создании деска:",
  },
  en: {
    createDesk: "Create Desk",
    confirm: "Confirm",
    fields: {
      name: "Name",
      description: "Description",
    },
    generalError: "An error occurred while creating the desk.",
    creationError: "Error creating desk:",
  },
};

export const AddDeskModal = ({ handleAddDeskModal, fetchDesks }) => {
  const { langSelected } = useContext(LangContext);
  const { theme } = useContext(ThemeContext);
  const isDark = theme === 'dark';
  const t = translations[langSelected] || translations.ru;

  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const modalRef = useRef(null);

  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      handleAddDeskModal();
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleAddDeskModal]);

  useEffect(() => {
    console.log(errors);
  }, [errors]);

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
    if (touched[key]) {
      setErrors((prev) => ({ ...prev, [key]: "" }));
    }
  };

  const handleFocus = (key) => {
    setErrors((prev) => ({ ...prev, [key]: "" }));
  };

  const handleBlur = (key) => {
    setTouched((prev) => ({ ...prev, [key]: true }));
  };

  const handleSubmit = async () => {
    const payload = {
      name: formData.name,
      description: formData.description || null,
    };

    try {
      await createDeskApi(payload);
      handleAddDeskModal();
      await fetchDesks();
    } catch (err) {
      console.error(t.creationError, err);
      if (err && err.errors) {
        setErrors(err.errors);
      } else if (err && err.message) {
        setErrors({ general: err.message });
      } else {
        setErrors({ general: t.generalError });
      }
    }
  };

  const fields = [
    { key: "name", label: t.fields.name },
    { key: "description", label: t.fields.description },
  ];

  return (
    <div className={`${styles.modal} ${isDark ? styles.darkModal : ''}`}>
      <div className={`${styles.filtersContainer} ${isDark ? styles.darkFiltersContainer : ''}`} ref={modalRef}>
        <div className={`${styles.modalLabel} ${isDark ? styles.darkModalLabel : ''}`}>
          <p className={`${isDark ? styles.darkModalLabelText : ''}`}>{t.createDesk}</p>
          <div onClick={handleAddDeskModal} className={`${isDark ? styles.darkModalLabelCloseButton : ''}`}><CloseIcon /></div>
        </div>

        <div className={styles.modalContent}>
          <div className={`${styles.section} ${isDark ? styles.darkSection : ''}`}>
            {fields.map(({ key, label }) => (
              <div key={key} className={styles.inputRow}>
                <label className={`${isDark ? styles.darkLabel : ''}`}>{label}:</label>
                <InputSelector
                  filterName={key}
                  selectedValue={formData[key]}
                  handleFilterChange={handleChange}
                  onFocus={() => handleFocus(key)}
                  onBlur={() => handleBlur(key)}
                  hasError={!!errors[key]}
                  errorMessage={errors[key]}
                  isTouched={touched[key]}
                  isDark={isDark}
                />
              </div>
            ))}
            {errors.general && <div className={styles.generalError}>{errors.general}</div>}
          </div>
        </div>

        <div className={`${styles.modalFooter} ${isDark ? styles.darkModalFooter : ''}`}>
          <div className={styles.confirmationWrapper}>
            <button className={`${styles.submitButton} ${isDark ? styles.darkSubmitButton : ''}`} onClick={handleSubmit}>
              {t.confirm}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};